module.exports = __webpack_public_path__ + "img/CS-ProfiNew_Overview-DA4_1.3959df1d.jpg";